module.exports = __webpack_public_path__ + "img/roots-and-herbs-active.113f3877.png";